import {useClient, useDictionary, useVipCustomer} from '@adamlip/okeoke.client';
import {CircularProgress, Drawer, DrawerBody, DrawerContent, DrawerFooter, DrawerHeader} from '@heroui/react';
import useBasket from 'hooks/useBasket';
import {useContext, useEffect, useState} from 'react';
import {UserContext} from 'contexts/UserContext';
import TakeAwayDeliverySlide from './Slides/TakeAwayDeliverSlide';
import BasketItems from './Slides/BasketItems';
import Payment from './Slides/Payment';
import {AppParamsContext} from 'contexts/AppParamsContext';
import {MainContext} from 'contexts/MainContext';
import BarSoftButton from 'components/_NewComponents/BarSoftButton';
import {BasketContext} from 'contexts/BasketContext';
import SelectLocationModal from 'components/Modals/SelectLocationModal';

export default function BasketModal({isOpen, setIsOpen}) {
	const {appParams, desktopView} = useContext(AppParamsContext);
	const {userData, isVipBrand} = useContext(UserContext);
	const {checkSavedTable, noSafeAreaInTheApp} = useContext(MainContext);
	const {getValue} = useDictionary();
	const {handleChangePaymentType, deliveryInfo, notes, setTakeAway, setOrderIdentifier, orderItems, orderItemsAssembled} = useBasket();
	const {setIsUserSelectedLocation, isUserSelectedLocation} = useContext(BasketContext);
	const {locations, selectedLocationUUID} = useClient();
	const [locationModalOpen, setLocationModalOpen] = useState(false);
	const [delivery, setDelivery] = useState(false);
	const [carPickUp, setCarPickUp] = useState(false);
	const [selectedTab, setSelectedTab] = useState('takeAway');
	const [orderSubmitLoading, setOrderSubmitLoading] = useState(false);
	const [usableMoney, setUsableMoney] = useState(0);
	const [allowSlide, setAllowSlide] = useState(true);
	const {getVipProfile} = useVipCustomer();
	const [activeSlideName, setActiveSlideName] = useState('basketItems');
	const [activePage, setActivePage] = useState('basketItems');
	const [paymentModalOpen, setPaymentModalOpen] = useState(false);
	const [payByVipMoney, setPayByVipMoney] = useState(false);

	const goToNext = () => {
		if (activePage === 'basketItems') {
			if (appParams?.basketModal?.visibleBlocks?.takeAwayDelivery) {
				setActivePage('takeAwayDelivery');
			} else {
				setActivePage('payment');
			}
		} else if (activePage === 'takeAwayDelivery') {
			setActivePage('payment');
		} else if (activePage === 'payment') {
			// setActivePage("basketItems");
		}
	};

	const onReachEnd = () => {
		checkSavedTable();
		if (isVipBrand && userData?.vipID) {
			getVipProfile(userData?.vipID).then((res) => {
				if (res.success) {
					setUsableMoney(res.data.money);
				} else {
					setUsableMoney(0);
				}
			});
		}
	};
	useEffect(() => {
		if (activePage === 'payment' && isOpen) {
			onReachEnd();
		}
	}, [activePage, isOpen]);
	useEffect(() => {
		if (isOpen) {
			let pos = userData?.email?.search('@');
			if (pos > 12) pos = 12;
			let shortEmail = userData?.email?.slice(0, pos);
			let savedIdentifier = localStorage['orderIdentifier'] != null && localStorage['orderIdentifier'] !== 'undefined' ? localStorage['orderIdentifier'] : null;
			let identifier = savedIdentifier || userData?.firstName || shortEmail || 'Anonymous';
			identifier = identifier.slice(0, 12);
			setOrderIdentifier(identifier);
			setTakeAway(appParams?.basketModal?.whereWhen?.defaultWhere === 'eatIn' ? 0 : 1);
			if (!isUserSelectedLocation && Object.values(locations || {})?.filter((loc) => loc.enabled)?.length > 0) {
				setLocationModalOpen(true);
			} else {
				setLocationModalOpen(false);
			}
		}
		//eslint-disable-next-line
	}, [isOpen]);

	useEffect(() => {
		if (appParams?.basketModal?.paymentTypes?.offline && appParams?.basketModal?.paymentTypes?.online) {
			handleChangePaymentType('Online');
		} else {
			if (appParams?.basketModal?.paymentTypes?.offline) {
				handleChangePaymentType('Offline');
			}
			if (appParams?.basketModal?.paymentTypes?.online) {
				handleChangePaymentType('Online');
			}
		}
		setTakeAway(appParams?.basketModal?.whereWhen?.defaultWhere === 'eatIn' ? 0 : 1);
		//eslint-disable-next-line
	}, [appParams]);

	useEffect(() => {
		if (activeSlideName === 'takeAway') {
			if (delivery) {
				if (deliveryInfo === null) {
					setAllowSlide(false);
				} else {
					setAllowSlide(true);
				}
			}
			if (selectedTab === 'carPickUp') {
				if (selectedTab === 'carPickUp' && (notes?.length || '') < 12) {
					setAllowSlide(false);
				} else {
					setAllowSlide(true);
				}
			}
			if (!delivery && selectedTab !== 'carPickUp') {
				setAllowSlide(true);
			}
		} else {
			setAllowSlide(true);
		}
	}, [selectedTab, notes, delivery, deliveryInfo, activeSlideName]);

	return (
		<>
			<SelectLocationModal isOpen={locationModalOpen} setIsOpen={setLocationModalOpen} isDismissable={false} />

			{!locationModalOpen && (
				<Drawer
					isOpen={isOpen}
					onOpenChange={() => {
						setIsOpen(!isOpen);
						setActivePage('basketItems');
					}}
					size={'full'}
					radius='none'
					placement='bottom'
					className='bg-background rounded-lg'
					classNames={{
						closeButton: `z-50 bg-primary text-primary-foreground ${noSafeAreaInTheApp ? 'top-14' : ''}`,
					}}>
					<DrawerContent>
						{(onClose) => (
							<>
								<DrawerHeader className={`bg-primary text-primary-foreground rounded-b-general text-2xl ${noSafeAreaInTheApp ? 'pt-14' : ''}`}>{getValue('app_v2_basket_title')}</DrawerHeader>
								<DrawerBody className='px-0 overflow-hidden flex flex-col gap-0'>
									{orderSubmitLoading && (
										<div className='absolute top-0 left-0 bottom-0 right-0 bg-black opacity-80 z-10 flex justify-center items-center'>
											<CircularProgress size='lg' color='primary' aria-label='aria label' />
										</div>
									)}

									{activePage === 'basketItems' && <BasketItems goToNext={goToNext} setIsOpen={setIsOpen} />}
									{activePage === 'takeAwayDelivery' && appParams?.basketModal?.visibleBlocks?.takeAwayDelivery && (
										<TakeAwayDeliverySlide goToNext={goToNext} setAllowSlide={setAllowSlide} delivery={delivery} setDelivery={setDelivery} carPickUp={carPickUp} setCarPickUp={setCarPickUp} selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
									)}
									{activePage === 'payment' && <Payment setOrderSubmitLoading={setOrderSubmitLoading} usableMoney={usableMoney} setIsOpen={setIsOpen} payByVipMoney={payByVipMoney} setPaymentModalOpen={setPaymentModalOpen} setPayByVipMoney={setPayByVipMoney} paymentModalOpen={paymentModalOpen} />}
								</DrawerBody>
								<DrawerFooter className='w-full flex-col flex gap-2 pt-0 px-2'>
									{Object.values(orderItemsAssembled || {})?.filter((item) => item?.parentOrderItemUUID == null && item?.count > 0)?.length > 0 && (
										<BarSoftButton
											onPress={() => {
												if (activePage === 'basketItems') {
													setIsOpen(false);
												} else {
													if (activePage === 'takeAwayDelivery') {
														setActivePage('basketItems');
													} else if (activePage === 'payment') {
														if (appParams?.basketModal?.visibleBlocks?.takeAwayDelivery) {
															setActivePage('takeAwayDelivery');
														} else {
															setActivePage('basketItems');
														}
													}
												}
											}}
											buttonName='basketModal'
											color='primary'
											forceCustom={true}
											variant='bordered'>
											{activePage === 'basketItems' ? getValue('app_v2_basket_close') : getValue('app_v2_basket_slider_previous')}
										</BarSoftButton>
									)}
									{noSafeAreaInTheApp && <div className='h-4 w-full' />}
								</DrawerFooter>
							</>
						)}
					</DrawerContent>
				</Drawer>
			)}
		</>
	);
}
